import React from 'react';
import ReactDOM from 'react-dom';

import VariantPicker from './variantPicker/VariantPicker';
import VariantPrice from './variantPicker/VariantPrice';
import VariantPickerStore from '../stores/variantPicker';

import {onAddToCartSuccess, onAddToCartError} from './cart';

export default $(document).ready((e) => {
  const variantPickerContainer = document.getElementById('variant-picker');
  const childVariantPickers = document.getElementsByClassName('variant-picker');
  const variantPickers = variantPickerContainer ? [variantPickerContainer].concat([...childVariantPickers]) : [...childVariantPickers];

  const variantPriceContainer = document.getElementById('variant-price-component');
  const childVariantPrice = document.getElementsByClassName('variant-price-component');
  const variantPrice = variantPriceContainer ? [variantPriceContainer].concat([...childVariantPrice]) : [...childVariantPrice];

  const variantProducts = {};

  if (variantPickers.length > 0) {
    for (const i in variantPickers) {
      const variantPickerData = JSON.parse(variantPickers[i].dataset.variantPickerData);
      const variantProductId = variantPickers[i].dataset.variantProductId;
      const variantPickerStore = new VariantPickerStore();
      variantProducts[variantProductId] = variantPickerData;
      variantProducts[`store-${variantProductId}`] = variantPickerStore;
      ReactDOM.render(
        <VariantPicker
          onAddToCartError={onAddToCartError}
          onAddToCartSuccess={onAddToCartSuccess}
          store={variantPickerStore}
          url={variantPickers[i].dataset.action}
          variantAttributes={variantPickerData.variantAttributes}
          variants={variantPickerData.variants}
          sizeChart={variantPickers[i].dataset.sizeChart}
        />,
        variantPickers[i]
      );
    }
  }

  if (variantPrice.length > 0) {
    for (const i in variantPrice) {
      const variantPriceId = variantPrice[i].dataset.variantProductId;
      const variantPriceData = variantProducts[variantPriceId];
      ReactDOM.render(
        <VariantPrice
          availability={variantPriceData.availability}
          priceDisplay={variantPriceData.priceDisplay}
          store={variantProducts[`store-${variantPriceId}`]}
        />,
        variantPrice[i]
      );
    }
  }
});
